import { Observable } from 'rxjs';

import { CurrencyPair } from '@api/exchange-rates';

export abstract class ExchangeRatesRepository {
  /**
   * getCurrencyPairs
   */
  public abstract getCurrencyPairs(): Observable<CurrencyPair>;
}
